import { useEffect, useState } from "react";
import { DOWN, UP } from "shared/constants";

const MINIMAL_SCROLL_DIFFERENCE = 20;

export function useScrollDirection() {
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);

  useEffect(() => {
    function onScroll() {
      const scroll = window.pageYOffset;
      const scrollDifference = lastScrollTop - scroll;
      const isScrollingDown = scroll > lastScrollTop;

      if (scroll <= MINIMAL_SCROLL_DIFFERENCE) {
        return setScrollDirection(null);
      }

      if (
        scrollDifference > MINIMAL_SCROLL_DIFFERENCE ||
        scrollDifference < -100
      ) {
        setLastScrollTop(scroll);
        const newScrollDirection = isScrollingDown ? DOWN : UP;

        if (newScrollDirection !== scrollDirection) {
          setScrollDirection(newScrollDirection);
        }
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [lastScrollTop]);

  return scrollDirection;
}
